import { Link } from 'react-router-dom';
import { featuredMatches } from '@/mocks/matches';

const statusLabels: Record<string, string> = {
  live: '进行中',
  upcoming: '即将开始',
  finished: '已结束',
};

const statusColors: Record<string, string> = {
  live: 'bg-primary-500',
  upcoming: 'bg-accent-500',
  finished: 'bg-foreground-400',
};

export default function FeaturedMatches() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门赛事
            </h2>
            <p className="mt-2 text-sm text-foreground-500">实时追踪全球顶级体育赛事动态</p>
          </div>
          <Link
            to="/category/football"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部赛事
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {featuredMatches.map((match) => (
            <div
              key={match.id}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs text-foreground-500 font-medium">{match.league}</span>
                <span
                  className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium text-background-50 ${statusColors[match.status]}`}
                >
                  {match.status === 'live' && (
                    <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse"></span>
                  )}
                  {statusLabels[match.status]}
                </span>
              </div>

              <div className="flex items-center justify-between mb-4">
                <div className="flex-1 text-center">
                  <p className="font-heading text-base font-semibold text-foreground-800">{match.homeTeam}</p>
                </div>
                <div className="px-4">
                  {match.status === 'upcoming' ? (
                    <span className="text-lg font-bold text-foreground-400 font-heading">VS</span>
                  ) : (
                    <span className="text-xl font-bold text-primary-600 font-heading">
                      {match.homeScore} - {match.awayScore}
                    </span>
                  )}
                </div>
                <div className="flex-1 text-center">
                  <p className="font-heading text-base font-semibold text-foreground-800">{match.awayTeam}</p>
                </div>
              </div>

              <div className="flex items-center justify-between pt-3 border-t border-background-200/60">
                <span className="text-xs text-foreground-500">{match.time}</span>
                <span className="text-xs text-foreground-400">
                  {match.category}
                  {match.categorySlug === 'tennis' || match.categorySlug === 'esports' ? ' · ' : ' · 主/平/客 '}
                  {'homeOdds' in match && match.homeOdds
                    ? `${match.homeOdds}${match.drawOdds ? ` / ${match.drawOdds} / ${match.awayOdds}` : ` / ${(match as any).awayOdds}`}`
                    : '实时赔率'}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/football"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 cursor-pointer"
          >
            查看全部赛事
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}